<template>
    <UpdateOperation></UpdateOperation>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UpdateOperation = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/UpdateOperation.vue"
    )
);

export default {
    name: "Project_HelpUpdateOperation", //The name you are in should not equal the name of the component you are importing.
    components: { UpdateOperation, AuthLayout },
};
</script>
